import type { Match } from '@uefadigital/panenka';

import MatchDescription from './MatchDescription';

interface MatchResultsProps {
  H2HMatchesToDisplay: Match[];
}

const MatchResults = ({ H2HMatchesToDisplay }: MatchResultsProps) => {
  return (
    <>
      {H2HMatchesToDisplay?.map((match: Match) => {
        return <MatchDescription key={match.id} match={match} />;
      })}
    </>
  );
};

export default MatchResults;
